import * as UsersActions from 'client/features/users/actions'
import RequestSagas from 'client/core/RequestSagas'
import { fork, put } from 'redux-saga/effects'
import URLS from 'constant/URLS'
import { browserHistory } from 'react-router'
import { makeEndpoint } from 'client/core/api'
import { flash } from 'client/features/flashes/actions'
export const getUsersSaga = new RequestSagas(UsersActions.UsersRequest.get, { method: 'GET', endpoint: URLS.users.get })
getUsersSaga.success = function* (action) {
    
}
getUsersSaga.failure = function* (action) {
    
}

export const postUsersSaga = new RequestSagas(UsersActions.UsersRequest.post, { method: 'POST', endpoint: URLS.users.get })
postUsersSaga.success = function* (action) {
    yield put(UsersActions.UsersRequest.get.action())
    browserHistory.push(makeEndpoint(URLS.users.show, action.payload.user))
    yield put(flash({ content: {
        type: 'success',
        title: 'Utilisateur créé.'
    } }))
}
postUsersSaga.failure = function* (action) {
    yield put(flash({ content: {
        type: 'error',
        title: 'Addresse email déjà utilisée.'
    } }))
}

export const putUsersSaga = new RequestSagas(UsersActions.UsersRequest.put, { method: 'PUT', endpoint: URLS.users.put })
putUsersSaga.success = function* (action) {
    if (action.payload.invite)
        yield put(flash({ content: {
            type: 'success',
            title: 'Client ré-invité.'
        } }))
    else
        yield put(flash({ content: {
            type: 'success',
            title: 'Utilisateur modifié.'
        } }))
    yield put(UsersActions.UsersRequest.get.action())
}
putUsersSaga.failure = function* (action) {
    
}


/*Export watchers sagas*/
const sagas = [
    fork(getUsersSaga.saga),
    fork(postUsersSaga.saga),
    fork(putUsersSaga.saga)
]

export default sagas


// WEBPACK FOOTER //
// ./src/client/features/users/sagas.js